<template>
  <ul class="flex text-gray-500 text-sm lg:text-base">
    <li
      v-for="(item,index) in items"
      :key="index"
      class="inline-flex items-center"
    >
      <inertia-link
        :href="item.link"
        :class="{'text-black font-semibold' : index == items.length - 1}"
      >{{item.label}}</inertia-link>
      <svg
        v-if="index < items.length - 1"
        class="h-5 w-auto text-gray-400"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </li>

  </ul>
</template>

<script>
export default {
  props: {
    items: Array
  }
}
</script>

<style>
</style>
